import { FSM, StateMachineConfig } from "../finite-state-machine";
import { ScannerState, scannerStateTransitions } from "./constants";

export class ScannerStateMachine {
  readonly config: StateMachineConfig<ScannerState>;
  constructor() {
    this.config = {
      transitions: scannerStateTransitions,
    };
  }
  canTransition(currentState: ScannerState, newState: ScannerState): boolean {
    return new FSM(this.config, currentState).canTransitionTo(newState);
  }

  assertCanTransition(
    currentState: ScannerState,
    newState: ScannerState
  ): void {
    if (!this.canTransition(currentState, newState)) {
      throw new Error(`Cannot transition from ${currentState} to ${newState}`);
    }
  }
}
